import { useMatches } from '@remix-run/react';
import { useMemo } from 'react';
import type {
    PageBuilderModuleType,
    TopBanner,
} from '@modules/page-builder/types';
import type { SerializeFrom } from '@remix-run/node';
import type { loader } from '~/routes/_app.project.$urlSegment._index';

const PROJECT_ROUTE = `routes/_app.project.$urlSegment._index`;
const PREVIEW_ROUTE = `routes/_app.project.$urlSegment.template.$url`;

interface TemplateData {
    Banner: TopBanner;
    Modules: PageBuilderModuleType[];
}

interface CombinedDataType extends SerializeFrom<typeof loader> {
    templateData?: TemplateData;
}

export const useProjectPreviewRouteData = () => {
    const matchingRoutes = useMatches();

    const combinedData = useMemo(() => {
        const filteredRoutes = matchingRoutes.filter((route) => {
            return [PROJECT_ROUTE, PREVIEW_ROUTE].includes(route.id);
        });

        return filteredRoutes.reduce((result, item) => {
            Object.assign(result, item.data);
            return result;
        }, {} as CombinedDataType);
    }, [matchingRoutes]);

    const { project, templateData } = combinedData;

    return {
        ...project,
        Banner: templateData?.Banner ?? project.Banner,
        Modules: templateData?.Modules ?? project.Modules,
    };
};
